import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getAccountDetail } from "./common/services";

export function safetyInstructionLoader() {
  return defer({
    coreData: resolveLoaderResult(getAccountDetail()),
  });
}
